import Skeleton from '@material-ui/lab/Skeleton'

import { tokenizer } from '../../../services/utils'
import l10n from '../../i18n/I18N'

import classes from './styles/cryptoPaymentWithdrawalFormTimer.module.scss'

export const CryptoPaymentWithdrawalFormTimer = ({ secondsToUpdateDraftData }) => {
  return (
    <div className={classes.cryptoPaymentWithdrawalFormTimer}>
      {secondsToUpdateDraftData > 0 && (
        <div>
          {tokenizer(l10n.t['cryptopayment.redeem.feeRefresh'], {
            '{time}': secondsToUpdateDraftData >= 10 ? secondsToUpdateDraftData : `0${secondsToUpdateDraftData}`
          })}
        </div>
      )}
      {secondsToUpdateDraftData < 1 && (
        <Skeleton className={classes.cryptoPaymentWithdrawalFormTimer__skeleton} animation="wave" variant="rect" />
      )}
    </div>
  )
}
